// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.option-fields[data-v-c524b2e8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0 -10px;\n}\n.option-fields__checkbox[data-v-c524b2e8] {\n  width: auto;\n  margin: 0 10px;\n}\n", ""]);
// Exports
module.exports = exports;
